var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticStyle:{"background-color":"#2e67a9"}},[_c('router-view')],1),_c('section',{staticClass:"footer"},[_c('div',[_vm._v("©RunBuilder. All rights reserved.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }